import { ImageResponse } from '../../modules/Restaurants/models/restaurant-image-response.model';

export const getSortedBoxesWithFiles = (boxes: ImageResponse[]): ImageResponse[] =>
  boxes.filter((box) => !!box.file).sort((a, b) => a.order - b.order);
